import CSInput from "src/components/Input/Index"
import CommonModal, { CommonModalProps } from "src/components/Modal"
import { Form } from "antd"
import { deactiveAccount } from "src/services/User"
import { message } from "antd"
import { useEffect } from "react"
import { useAppDispatch } from "src/app/hooks"
import { logout } from "src/features/user/userSlice"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"

type DeactiveAccountProps = {
  handleClose: () => void
  handleOpenForgotPassword?: () => void
} & CommonModalProps

const DeactiveAccount: React.FC<DeactiveAccountProps> = ({
  handleClose,
  handleOpenForgotPassword,
  isOpen,
  ...props
}) => {
  const [searchParams] = useSearchParams()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()

  const onFinish = async (values: any) => {
    // console.log(values)

    try {
      const resp: any = await deactiveAccount({
        password: values.password,
        trxUID: searchParams.get("trxUID") || undefined,
      })
      if (resp?.result) {
        dispatch(logout())
      } else {
        form.setFields([
          {
            name: "password",
            errors: [
              t(
                "Password is not correct. Please check your password carefully",
              ),
            ],
          },
        ])
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (isOpen === false) {
      form.resetFields()
    }
  }, [isOpen])

  return (
    <CommonModal isOpen={isOpen} handleClose={handleClose} {...props}>
      <p className="font-pretendard500 text-[20px]">{t("계정 비활성화")}</p>
      <p className="text-gray1 text-[14px]">
        {t("Please enter your password below to confirm")}
      </p>
      <div className="mt-[28px]">
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          onFinish={onFinish}
        >
          <CSInput
            inputType="password"
            name="password"
            placeholder={t("입력하세요.")}
            inputHeight={48}
            className="!mb-[10px]"
            borderColor="#D4D4D4"
            rules={[
              {
                required: true,
              },
            ]}
          />
          <div className="flex items-center gap-[10px] mb-[40px]">
            <button
              className="w-full border-[1px] border-primary h-[48px]"
              onClick={handleClose}
              type="button"
            >
              {t("Cancel")}
            </button>
            <button className="bg-primary w-full h-[48px] font-pretendard700 text-primaryWhite">
              {t("Deactivate account")}
            </button>
          </div>
          <div className="flex justify-center mb-[19px]">
            <button
              className="text-end text-primary underline"
              onClick={handleOpenForgotPassword}
              type="button"
            >
              {t("Forgot password?")}
            </button>
          </div>
        </Form>
      </div>
    </CommonModal>
  )
}

export default DeactiveAccount
